import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const OpenIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M6.5 5C5.67157 5 5 5.67157 5 6.5V17.5C5 18.3284 5.67157 19 6.5 19H17.5C18.3284 19 19 18.3284 19 17.5V14C19 13.4477 19.4477 13 20 13C20.5523 13 21 13.4477 21 14V17.5C21 19.433 19.433 21 17.5 21H6.5C4.567 21 3 19.433 3 17.5V6.5C3 4.567 4.567 3 6.5 3H10C10.5523 3 11 3.44772 11 4C11 4.55228 10.5523 5 10 5H6.5ZM14.9268 5C14.3745 5 13.9268 4.55228 13.9268 4C13.9268 3.44772 14.3745 3 14.9268 3H19.9268C20.479 3 20.9268 3.44772 20.9268 4V9C20.9268 9.55228 20.479 10 19.9268 10C19.3745 10 18.9268 9.55228 18.9268 9V6.41421L8.63386 16.7071C8.24334 17.0976 7.61018 17.0976 7.21965 16.7071C6.82913 16.3166 6.82913 15.6834 7.21965 15.2929L17.5125 5H14.9268Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

OpenIcon.propTypes = {
  ...sizePropsTypes,
};

export default OpenIcon;
